import { render, staticRenderFns } from "./ChatGPT.pug?vue&type=template&id=c8bc754c&lang=pug&external"
import script from "./ChatGPT.js?vue&type=script&lang=js&external"
export * from "./ChatGPT.js?vue&type=script&lang=js&external"
import style0 from "./ChatGPT.vue?vue&type=style&index=0&id=c8bc754c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports